
import { Vue, Component } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import EventBus from "../utils/EventBus";
import { SET_APP_LOCALE } from "../store/action-types";
import { getSupportedLanguagesForDropdown } from "../utils/helpers";

@Component
export default class AppSettings extends Vue {
  @Getter("app/locale") currentLocale: string;

  @Action(`app/${SET_APP_LOCALE}`) setAppLocale: (locale: string) => void;

  dialogVisible = true;

  selectedLanguage = "";

  get supportedLanguages() {
    return getSupportedLanguagesForDropdown();
  }

  async created() {
    this.selectedLanguage = this.currentLocale;
  }

  closeDialog() {
    this.dialogVisible = false;
    EventBus.$emit("hide-app-settings");
  }

  async saveSettings() {
    this.setAppLocale(this.selectedLanguage);
    this.closeDialog();
  }
}
